import React from 'react';


export const GlobalImageSelector = ({ id }: any) => {
    switch (id) {
        case 0:
            return <img src="icons/01d.png" alt="Clear sky icon" />;
        case 1:
        case 2:
            return <img src="icons/02d.png" alt="Partly cloudy icon" />;
        case 3:
            return <img src="icons/04d.png" alt="Overcast" />;
        case 45:
        case 48:
            return <img src="icons/50d.png" alt="Fog icon" />;
        case 51:
        case 53:
        case 55:
            return <img src="icons/09d.png" alt="Drizzle icon" />;
        case 56:
        case 57:
            return <img src="icons/09d.png" alt="Freezing drizzle icon" />;
        case 61:
        case 63:
        case 65:
            return <img src="icons/10d.png" alt="Rain icon" />;
        case 66:
        case 67:
            return <img src="icons/10d.png" alt="Freezing rain icon" />;
        case 71:
        case 73:
        case 75:
            return <img src="icons/13d.png" alt="Snow fall icon" />;
        case 77:
            return <img src="icons/13d.png" alt="Snow grains icon" />;
        case 80:
        case 81:
        case 82:
            return <img src="icons/10d.png" alt="Rain showers icon" />;
        case 85:
        case 86:
            return <img src="icons/13d.png" alt="Snow showers icon" />;
        case 95:
            return <img src="icons/11d.png" alt="Thunderstorm icon" />;
        case 96:
        case 99:
            return <img src="icons/11d.png" alt="Hail icon" />;
        default:
            return <p>error</p>;
    }
}



